export const resolveScheduleId = (schedule) =>
  schedule?.id ??
  schedule?.scheduleId ??
  schedule?.schedule_id ??
  schedule?.definitionId ??
  schedule?.definition_id ??
  null;

export const resolveScheduleEntityType = (schedule) =>
  `${schedule?.entity?.type ?? schedule?.entityType ?? schedule?.entity_type ?? ''}`
    .trim()
    .toLowerCase();

export const resolveScheduleEntityId = (schedule) =>
  schedule?.entity?.entity_id ??
  schedule?.entity?.id ??
  schedule?.entityId ??
  schedule?.entity_id ??
  null;

export const resolveScheduleZoneIds = (schedule) => {
  if (!schedule || typeof schedule !== 'object') return [];
  const ids = [];
  const pushId = (value) => {
    if (value == null || value === '') return;
    const key = `${value}`;
    if (!ids.some((id) => `${id}` === key)) ids.push(value);
  };

  if (schedule?.zone?.id != null) pushId(schedule.zone.id);
  if (Array.isArray(schedule?.zone)) {
    schedule.zone.forEach((zone) => pushId(zone?.id ?? zone));
  }
  if (Array.isArray(schedule?.zones)) {
    schedule.zones.forEach((zone) => pushId(zone?.id ?? zone));
  }
  if (Array.isArray(schedule?.zone_ids)) schedule.zone_ids.forEach(pushId);
  if (Array.isArray(schedule?.zoneIds)) schedule.zoneIds.forEach(pushId);
  if (schedule?.zone_id != null) pushId(schedule.zone_id);
  if (schedule?.zoneId != null) pushId(schedule.zoneId);
  if (resolveScheduleEntityType(schedule) === 'zone' && resolveScheduleEntityId(schedule) != null) {
    pushId(resolveScheduleEntityId(schedule));
  }
  return ids;
};

export const resolveScheduleTour = (schedule, tours = []) => {
  if (!schedule || typeof schedule !== 'object') return null;
  const isTourEntity = resolveScheduleEntityType(schedule) === 'tour';
  const direct =
    schedule?.tour ??
    schedule?.tourData ??
    schedule?.entity?.tour ??
    (isTourEntity ? schedule?.entity?.data : null) ??
    null;
  if (
    direct &&
    typeof direct === 'object' &&
    (direct.id != null ||
      direct.nodes ||
      direct.checkpoints ||
      direct.legs ||
      direct.encodedPolyline)
  ) {
    return direct;
  }

  const tourId =
    schedule?.tour_id ??
    schedule?.tourId ??
    schedule?.entity?.tour_id ??
    schedule?.entity?.tourId ??
    (isTourEntity ? resolveScheduleEntityId(schedule) : null);
  if (tourId == null) return null;

  return Array.isArray(tours)
    ? tours.find((tour) => `${tour?.id ?? tour?.tourId}` === `${tourId}`) || null
    : null;
};

export const resolveSchedulePersonnelIds = (schedule) => {
  if (Array.isArray(schedule?.personnel_ids)) return schedule.personnel_ids;
  if (Array.isArray(schedule?.personnelIds)) return schedule.personnelIds;
  if (schedule?.personnel_id != null) return [schedule.personnel_id];
  if (schedule?.personnelId != null) return [schedule.personnelId];
  return [];
};
